import React from 'react';
import {PropTypes} from 'prop-types';
import DirectNavigationModel from '../DirectNavigationModel';
import './MobileMenu.less';
import DropdownMenu from '../DropdownMenu/DropdownMenu.react';
import LocaleContext from '../../../../../Contexts/Locale/Context';

class MobileMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            label: '',
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const {label, ...rest} = prevState;
        const {labelKey, labelTable} = DirectNavigationModel.getLabelKeyAndTable(
            nextProps.navigation,
            nextProps.sphereId
        );
        return {
            ...rest,
            labelKey,
            labelTable,
        };
    }

    handleSpaceSelected = (sphereId) => {
        if (this.props.onSelectNavSpace) {
            this.props.onSelectNavSpace(sphereId);
        }
        document.activeElement.blur();
    };

    render() {
        /* todo: Fix text wrap and spacing for long text, such as an unfound translation*/

        let classString = 'MobileMenu Floating';

        return (
            <div className={classString}>
                <LocaleContext.Consumer>
                    {(getTranslation) => (
                        <DropdownMenu
                            {...this.props}
                            label={''}
                            onSphereSelected={this.handleSpaceSelected}
                            onOpen={this.props.onOpen}
                            onClose={this.props.onClose}
                            useMediaGateway={this.props.useMediaGateway}
                            customToggle={
                                <span className={`MobileMenu__cta`}>
                                    {this.state.labelKey !== 'directNav.exploreMore' ? (
                                        <div className={`MobileMenu__header`}>
                                            <span className="label MobileMenu__title">
                                                {this.props.labelTitle}
                                            </span>
                                            <span className="label MobileMenu__space">
                                                {
                                                    <span>
                                                        {getTranslation(
                                                            this.state.labelTable,
                                                            this.state.labelKey
                                                        )}
                                                    </span>
                                                }
                                            </span>
                                        </div>
                                    ) : null}

                                    <div className={`MobileMenu__body`}>
                                        <a
                                            href={''}
                                            className={`MobileMenu__ctaText`}
                                            onClick={(e) => {
                                                e.preventDefault();
                                            }}
                                        >
                                            {this.props.ctaText}
                                        </a>
                                    </div>
                                </span>
                            }
                        />
                    )}
                </LocaleContext.Consumer>
            </div>
        );
    }
}

MobileMenu.propTypes = {
    navigation: DirectNavigationModel.navigationType.isRequired,
    sphereId: PropTypes.string.isRequired,
    onSelectNavSpace: PropTypes.func,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    labelTitle: PropTypes.string,
    ctaText: PropTypes.string,
    useMediaGateway: PropTypes.bool,
};

MobileMenu.defaultProps = {
    className: 'MobileMenu',
    labelTitle: 'Currently viewing:',
    ctaText: 'Explore more',
};

export default MobileMenu;
